import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { getFormattedUrl } from 'shared/helpers/VideoUrlsHelper'

const Stream = (props) => {
  const [streamUrl, setStreamUrl] = useState()

  useEffect(() => {
    getFormattedUrl(props.url)
      .then(setStreamUrl)
  }, [])

  return (
    <div className='live-event-stream-iframe-wrapper'>
      <iframe
        className="live-event-stream-iframe"
        src={streamUrl}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen/>
    </div>
  )
}

Stream.propTypes = {
  url: PropTypes.string.isRequired
}

export default Stream
